module.exports = __webpack_public_path__ + "static/media/arrows-down.d9f46086.webp";